export const generateGrid = (words, gridSize = 15) => {
  const grid = Array.from({ length: gridSize }, () => Array(gridSize).fill(null));
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const placedWords = [];

  words.forEach((wordObj) => {
      const word = wordObj.Word.toUpperCase();
      const positions = [];
      let placed = false;

      while (!placed) {
          // Randomly choose one of the four directions
          const directions = ['horizontal', 'vertical', 'diagonal-tl-br', 'diagonal-bl-tr'];
          const direction = directions[Math.floor(Math.random() * directions.length)];
          
          let startX, startY, valid = true;

          if (direction === 'horizontal') {
              startX = Math.floor(Math.random() * (gridSize - word.length));
              startY = Math.floor(Math.random() * gridSize);
          } else if (direction === 'vertical') {
              startX = Math.floor(Math.random() * gridSize);
              startY = Math.floor(Math.random() * (gridSize - word.length));
          } else if (direction === 'diagonal-tl-br') {
              startX = Math.floor(Math.random() * (gridSize - word.length));
              startY = Math.floor(Math.random() * (gridSize - word.length));
          } else if (direction === 'diagonal-bl-tr') {
              startX = Math.floor(Math.random() * (gridSize - word.length));
              startY = Math.floor(Math.random() * (gridSize - word.length)) + word.length - 1;
          }

          // Check if the word can fit
          for (let i = 0; i < word.length; i++) {
              const x = startX + (direction === 'horizontal' ? i : direction === 'vertical' ? 0 : i);
              const y = startY + (direction === 'vertical' ? i : direction === 'horizontal' ? 0 : direction === 'diagonal-tl-br' ? i : -i);

              // Check bounds and collisions
              if (x < 0 || x >= gridSize || y < 0 || y >= gridSize || (grid[y][x] && grid[y][x] !== word[i])) {
                  valid = false;
                  break;
              }
          }

          if (valid) {
              // Place the word
              for (let i = 0; i < word.length; i++) {
                  const x = startX + (direction === 'horizontal' ? i : direction === 'vertical' ? 0 : i);
                  const y = startY + (direction === 'vertical' ? i : direction === 'horizontal' ? 0 : direction === 'diagonal-tl-br' ? i : -i);

                  grid[y][x] = word[i];
                  positions.push({ x, y });
              }
              placed = true;
              placedWords.push({ word, positions });
          }
      }
  });

  // Fill empty spaces with random letters
  for (let y = 0; y < gridSize; y++) {
      for (let x = 0; x < gridSize; x++) {
          if (!grid[y][x]) {
              grid[y][x] = alphabet[Math.floor(Math.random() * alphabet.length)];
          }
      }
  }

  return { grid, placedWords };
};


// // GridGenerator.js
// export const generateGrid = (words, gridSize = 15) => {
//     const grid = Array.from({ length: gridSize }, () => Array(gridSize).fill(null));
//     const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//     const placedWords = [];
  
//     words.forEach((wordObj) => {
//       const word = wordObj.Word.toUpperCase();
//       const positions = [];
//       let placed = false;
  
//       while (!placed) {
//         const direction = Math.random() > 0.5 ? 'horizontal' : 'vertical';
//         const startX = Math.floor(Math.random() * (direction === 'horizontal' ? gridSize - word.length : gridSize));
//         const startY = Math.floor(Math.random() * (direction === 'vertical' ? gridSize - word.length : gridSize));
//         let valid = true;
  
//         // Check if word fits without collisions
//         for (let i = 0; i < word.length; i++) {
//           const x = startX + (direction === 'horizontal' ? i : 0);
//           const y = startY + (direction === 'vertical' ? i : 0);
  
//           if (grid[y][x] && grid[y][x] !== word[i]) {
//             valid = false;
//             break;
//           }
//         }
  
//         if (valid) {
//           // Place the word
//           for (let i = 0; i < word.length; i++) {
//             const x = startX + (direction === 'horizontal' ? i : 0);
//             const y = startY + (direction === 'vertical' ? i : 0);
//             grid[y][x] = word[i];
//             positions.push({ x, y });
//           }
//           placed = true;
//           placedWords.push({ word, positions });
//         }
//       }
//     });
  
//     // Fill empty spaces with random letters
//     for (let y = 0; y < gridSize; y++) {
//       for (let x = 0; x < gridSize; x++) {
//         if (!grid[y][x]) {
//           grid[y][x] = alphabet[Math.floor(Math.random() * alphabet.length)];
//         }
//       }
//     }
  
//     return { grid, placedWords };
//   };
  
  